export const WRAPPED_COMPONENT_KEY = 'wrappedComponent';
export const DEFAULT_RELEVANCY = 'Default Relevancy';
export const SESSION_EXPIRATION_TIMEOUT = 1800000;
export const SESSION_INACTIVE_TIMEOUT = 300000;
export const DATE_FORMAT_HOUR = 'YYYYMMDDHH';
export const DEFAULT_CACHE_TTL = 600000;
export var Role;
(function (Role) {
    Role.SEO_MANAGER = 'seo_manager';
    Role.MERCHANDISING = 'merchandising';
    Role.QUERY_REWRITE = 'queryRewrite';
    Role.ENGINE_CONFIGURATION = 'engineConfiguration';
    Role.ADMIN = 'admin';
    Role.ANALYTICS = 'analytics';
})(Role || (Role = {}));
// user roles
export var SearchForRetailRole;
(function (SearchForRetailRole) {
    SearchForRetailRole["SuperAdmin"] = "SUPERADMIN";
    SearchForRetailRole["Admin"] = "ADMIN";
    SearchForRetailRole["Merchandiser"] = "MERCHANDISER";
    SearchForRetailRole["Seo_manager"] = "SEO_MANAGER";
    SearchForRetailRole["TenantAdmion"] = "TENANTADMIN";
})(SearchForRetailRole || (SearchForRetailRole = {}));
// area permission roles
export var SearchForRetailPermissionRole;
(function (SearchForRetailPermissionRole) {
    SearchForRetailPermissionRole["Guest"] = "GUEST";
    SearchForRetailPermissionRole["Merchandiser"] = "MERCHANDISER";
    SearchForRetailPermissionRole["Seo_manager"] = "SEO_MANAGER";
})(SearchForRetailPermissionRole || (SearchForRetailPermissionRole = {}));
export const EDITING_ALLOWED_PERMISSION_ROLES = [SearchForRetailPermissionRole.Merchandiser];
export const SEO_EDITING_ALLOWED_PERMISSION_ROLES = [SearchForRetailPermissionRole.Seo_manager];
export const ADMIN_ROLE_NAME = SearchForRetailPermissionRole.Merchandiser;
export var ModelType;
(function (ModelType) {
    ModelType.RULE = 'rule';
    ModelType.ZONE = 'zone';
    ModelType.BIASING_PROFILE = 'biasingProfile';
    ModelType.REDIRECT = 'redirect';
    ModelType.TEMPLATE = 'template';
    ModelType.PREVIEW_WRAPPER = 'previewWrapper';
    ModelType.NAVIGATION = 'navigation';
    ModelType.AREA = 'area';
    ModelType.USER = 'user';
    ModelType.PERMISSION_ROLE = 'permissionRole';
    ModelType.TAG = 'tag';
    ModelType.PROJECT_CONFIGURATION = 'projectConfiguration';
    ModelType.TENANT = 'tenant';
    ModelType.INGESTION_TASKS = 'tasks';
    ModelType.FILTER_SETS = 'filterSets';
    ModelType.ATTRIBUTES = 'attributes';
    ModelType.LINGUISTIC_CONTROLS = 'linguisticControls';
    ModelType.PRODUCT_RECOMMENDATIONS = 'productRecommendations';
    ModelType.SITE = 'site';
    ModelType.AUTOCOMPLETE = 'autocomplete';
    ModelType.RECS_MODEL = 'recsModel';
    ModelType.CATEGORIES = 'categories';
    ModelType.IMAGE_PATH = 'imagePath';
    ModelType.PLACEMENT = 'placement';
})(ModelType || (ModelType = {}));
export var PageIdentifier;
(function (PageIdentifier) {
    PageIdentifier.HOME_DASHBOARDS = 'homeDashboards';
    PageIdentifier.RULE_EXPERIMENTS = 'ruleExperiments';
    PageIdentifier.ANALYTICS = 'analytics';
    PageIdentifier.SEO_DASHBOARD = 'seoDashboard';
    PageIdentifier.KEYWORD_SUGGESTIONS = 'keywordSuggestions';
    PageIdentifier.SITEMAP = 'sitemap';
    PageIdentifier.SEO_SUITE_SETTINGS = 'seoSuiteSettings';
    PageIdentifier.AUDIT_LOG = 'auditLog';
    PageIdentifier.EVALUATE = 'evaluate';
    PageIdentifier.SEARCH_PERFORMANCE = 'searchPerformance';
    PageIdentifier.SEARCH_DATA_QUALITY = 'dataQuality';
    PageIdentifier.PIPELINE_HEALTH = 'pipelineHealth';
    PageIdentifier.RELEASE_NOTES = 'releaseNotes';
})(PageIdentifier || (PageIdentifier = {}));
export var ChartType;
(function (ChartType) {
    ChartType.RECORD_COUNT = 'recordCount';
    ChartType.QPS = 'qps';
})(ChartType || (ChartType = {}));
export var ChartName;
(function (ChartName) {
    ChartName["QPS"] = "qps";
    ChartName["TOTAL_QUERIES"] = "totalQueries";
    ChartName["MONTHLY_SNAPSHOT"] = "monthlySnapshot";
    ChartName["QPS_DISTRIBUTION"] = "qpsDistribution";
    ChartName["SEARCH_CONVERSION_FUNNEL"] = "searchConversionFunnel";
    ChartName["QUERY_VOLUME"] = "queryVolume";
    ChartName["ERRORS"] = "errors";
    ChartName["API_RESPONSE_TIME"] = "apiResponseTime";
})(ChartName || (ChartName = {}));
export const SectionPath = {
    ADMIN: 'admin',
    SEO_STUDIO: 'seoStudio',
    ANALYTICS: 'analytics',
    MERCHANDISING: 'merchandising',
    ENRICH: 'enrich',
    RELEASE_NOTES: 'releaseNotes',
};
export var Routing;
(function (Routing) {
    Routing.CREATE_MODEL_SEGMENT = '_create';
    Routing.MERCHANDISING_PATH = '/merchandising';
    Routing.ENRICH_PATH = '/enrich';
    Routing.MODEL_MANAGER_PATH = `${Routing.MERCHANDISING_PATH}/:model/:collection?/:area?`;
    Routing.MODEL_CREATOR_PATH = `${Routing.MERCHANDISING_PATH}/:model/:collection?/:area?/${Routing.CREATE_MODEL_SEGMENT}`;
    Routing.LOGIN_PATH = '/login';
    /** Maps each RouteIdentifier to its corresponding URL path segment. */
    Routing.ROUTE_PATHS = {
        [ModelType.RULE]: 'rules',
        [PageIdentifier.SEO_DASHBOARD]: 'seoDashboard',
        [PageIdentifier.KEYWORD_SUGGESTIONS]: 'keywordSuggestions',
        [PageIdentifier.SITEMAP]: 'sitemap',
        [PageIdentifier.SEO_SUITE_SETTINGS]: 'seoSuiteSettings',
        [ModelType.ZONE]: 'zones',
        [ModelType.BIASING_PROFILE]: 'biasingProfiles',
        [ModelType.REDIRECT]: 'redirects',
        [ModelType.TEMPLATE]: 'templates',
        [ModelType.PREVIEW_WRAPPER]: 'previewWrapper',
        [ModelType.NAVIGATION]: 'navigations',
        [ModelType.AREA]: 'areas',
        [ModelType.USER]: 'users',
        [ModelType.TAG]: 'tags',
        [PageIdentifier.AUDIT_LOG]: 'auditLog',
        [PageIdentifier.RELEASE_NOTES]: 'releaseNotes',
        [PageIdentifier.ANALYTICS]: 'analytics',
        [ModelType.INGESTION_TASKS]: 'tasks',
        [ModelType.FILTER_SETS]: 'filterSets',
        [ModelType.ATTRIBUTES]: 'attributes',
        [ModelType.LINGUISTIC_CONTROLS]: 'linguisticControls',
        [PageIdentifier.HOME_DASHBOARDS]: 'merchandising',
        [PageIdentifier.EVALUATE]: 'evaluate',
        [ModelType.PRODUCT_RECOMMENDATIONS]: 'productRecommendations',
        [ModelType.SITE]: 'sites',
        [ModelType.AUTOCOMPLETE]: 'autocomplete',
        [ModelType.RECS_MODEL]: 'recsModel',
        [ModelType.CATEGORIES]: 'categories',
        [ModelType.IMAGE_PATH]: 'imagePath',
        [PageIdentifier.SEARCH_DATA_QUALITY]: 'dataQuality',
        [PageIdentifier.PIPELINE_HEALTH]: 'pipelineHealth',
        [PageIdentifier.SEARCH_PERFORMANCE]: 'searchPerformance',
    };
})(Routing || (Routing = {}));
export var SearchForRetail;
(function (SearchForRetail) {
    let BiasingStrategyStrength;
    (function (BiasingStrategyStrength) {
        BiasingStrategyStrength[BiasingStrategyStrength["ABSOLUTE_DECREASE"] = 0] = "ABSOLUTE_DECREASE";
        BiasingStrategyStrength[BiasingStrategyStrength["STRONG_DECREASE"] = 1] = "STRONG_DECREASE";
        BiasingStrategyStrength[BiasingStrategyStrength["MEDIUM_DECREASE"] = 2] = "MEDIUM_DECREASE";
        BiasingStrategyStrength[BiasingStrategyStrength["WEAK_DECREASE"] = 3] = "WEAK_DECREASE";
        BiasingStrategyStrength[BiasingStrategyStrength["LEAVE_UNCHANGED"] = 4] = "LEAVE_UNCHANGED";
        BiasingStrategyStrength[BiasingStrategyStrength["WEAK_INCREASE"] = 5] = "WEAK_INCREASE";
        BiasingStrategyStrength[BiasingStrategyStrength["MEDIUM_INCREASE"] = 6] = "MEDIUM_INCREASE";
        BiasingStrategyStrength[BiasingStrategyStrength["STRONG_INCREASE"] = 7] = "STRONG_INCREASE";
        BiasingStrategyStrength[BiasingStrategyStrength["ABSOLUTE_INCREASE"] = 8] = "ABSOLUTE_INCREASE";
    })(BiasingStrategyStrength = SearchForRetail.BiasingStrategyStrength || (SearchForRetail.BiasingStrategyStrength = {}));
    SearchForRetail.BIASING_STRATEGY_STRENGTH_LOCALIZED_MESSAGE_KEY = {
        [BiasingStrategyStrength.ABSOLUTE_DECREASE]: 'BIASING_STRATEGY_FORM_INFLUENCESLIDER_ABSOLUTEDECREASE',
        [BiasingStrategyStrength.STRONG_DECREASE]: 'BIASING_STRATEGY_FORM_INFLUENCESLIDER_STRONGDECREASE',
        [BiasingStrategyStrength.MEDIUM_DECREASE]: 'BIASING_STRATEGY_FORM_INFLUENCESLIDER_MEDIUMDECREASE',
        [BiasingStrategyStrength.WEAK_DECREASE]: 'BIASING_STRATEGY_FORM_INFLUENCESLIDER_WEAKDECREASE',
        [BiasingStrategyStrength.LEAVE_UNCHANGED]: 'BIASING_STRATEGY_FORM_INFLUENCESLIDER_UNCHANGED',
        [BiasingStrategyStrength.WEAK_INCREASE]: 'BIASING_STRATEGY_FORM_INFLUENCESLIDER_WEAKINCREASE',
        [BiasingStrategyStrength.MEDIUM_INCREASE]: 'BIASING_STRATEGY_FORM_INFLUENCESLIDER_MEDIUMINCREASE',
        [BiasingStrategyStrength.STRONG_INCREASE]: 'BIASING_STRATEGY_FORM_INFLUENCESLIDER_STRONGINCREASE',
        [BiasingStrategyStrength.ABSOLUTE_INCREASE]: 'BIASING_STRATEGY_FORM_INFLUENCESLIDER_ABSOLUTEINCREASE',
    };
    let TriggerType;
    (function (TriggerType) {
        TriggerType["CONTAINS"] = "CONTAINS";
        TriggerType["ENDS_WITH"] = "ENDS_WITH";
        TriggerType["REGEX"] = "REGEX";
        TriggerType["STARTS_WITH"] = "STARTS_WITH";
        TriggerType["MATCHES"] = "MATCHES";
        TriggerType["CUSTOM_PARAMETER"] = "CUSTOM_PARAMETER";
        TriggerType["NAVIGATION_RANGE"] = "RANGE";
        TriggerType["NAVIGATION_SELECTED"] = "NAVIGATION_SELECTED";
        TriggerType["NAVIGATION_VALUE"] = "VALUE";
    })(TriggerType = SearchForRetail.TriggerType || (SearchForRetail.TriggerType = {}));
    let FilterType;
    (function (FilterType) {
        FilterType["FILTERED_BY"] = "FilteredBy";
        FilterType["SEARCH"] = "Search";
        FilterType["RANGE"] = "Range";
        FilterType["EXCLUSION"] = "Exclusion";
    })(FilterType = SearchForRetail.FilterType || (SearchForRetail.FilterType = {}));
    SearchForRetail.triggerMap = {
        [TriggerType.CONTAINS]: 'queryPatternTriggers',
        [TriggerType.ENDS_WITH]: 'queryPatternTriggers',
        [TriggerType.REGEX]: 'queryPatternTriggers',
        [TriggerType.STARTS_WITH]: 'queryPatternTriggers',
        [TriggerType.MATCHES]: 'queryPatternTriggers',
        [TriggerType.CUSTOM_PARAMETER]: 'customParameterTriggers',
        [TriggerType.NAVIGATION_RANGE]: 'selectedRefinementTriggers',
        [TriggerType.NAVIGATION_SELECTED]: 'selectedRefinementTriggers',
        [TriggerType.NAVIGATION_VALUE]: 'selectedRefinementTriggers',
    };
    SearchForRetail.MODEL_TYPE_DISPLAY_NAMES_LOCALIZED_MESSAGE_KEY = {
        [PageIdentifier.ANALYTICS]: 'ANALYTICS',
        [ModelType.RULE]: 'RULE',
        [ModelType.BIASING_PROFILE]: 'BIASING_STRATEGY',
        [ModelType.NAVIGATION]: 'FACETS',
        [ModelType.REDIRECT]: 'REDIRECT',
        [ModelType.ZONE]: 'ZONE',
        [ModelType.TEMPLATE]: 'TEMPLATE',
        [ModelType.AREA]: 'AREA',
        [ModelType.USER]: 'USER',
        [ModelType.PROJECT_CONFIGURATION]: 'PROJECT_CONFIGURATION',
        [ModelType.TENANT]: 'TENANT',
        [ModelType.TAG]: 'TAG',
        [ModelType.FILTER_SETS]: 'FILTER_SETS',
        [ModelType.ATTRIBUTES]: 'ATTRIBUTES',
        [ModelType.LINGUISTIC_CONTROLS]: 'LINGUISTIC_CONTROLS',
        [ModelType.RECS_MODEL]: 'RECS_MODELS',
        [ModelType.IMAGE_PATH]: 'IMAGE_PATH',
        [PageIdentifier.SEARCH_DATA_QUALITY]: 'SEARCH_DATA_QUALITY',
        [ModelType.PLACEMENT]: 'PLACEMENT',
        [ModelType.PRODUCT_RECOMMENDATIONS]: 'PRODUCT_RECOMMENDATIONS',
    };
    let ActionType;
    (function (ActionType) {
        ActionType["Create"] = "create";
        ActionType["Review"] = "review";
        ActionType["Save"] = "save";
        ActionType["None"] = "none";
        ActionType["DataTransfer"] = "dataTransfer";
        ActionType["Counter"] = "Counter";
    })(ActionType = SearchForRetail.ActionType || (SearchForRetail.ActionType = {}));
    let PageType;
    (function (PageType) {
        PageType["GLOBAL"] = "global";
        PageType["AREA"] = "area";
        PageType["SITE"] = "site";
        PageType["COLLECTION"] = "collection";
    })(PageType = SearchForRetail.PageType || (SearchForRetail.PageType = {}));
    SearchForRetail.PAGE_TYPE_MAP = {
        [ModelType.RULE]: PageType.AREA,
        [ModelType.BIASING_PROFILE]: PageType.AREA,
        [ModelType.ZONE]: PageType.AREA,
        [ModelType.REDIRECT]: PageType.AREA,
        [ModelType.NAVIGATION]: PageType.AREA,
        [ModelType.ATTRIBUTES]: PageType.COLLECTION,
        [ModelType.LINGUISTIC_CONTROLS]: PageType.AREA,
        [ModelType.PRODUCT_RECOMMENDATIONS]: PageType.COLLECTION,
        [ModelType.FILTER_SETS]: PageType.COLLECTION,
        [ModelType.INGESTION_TASKS]: PageType.GLOBAL,
        [ModelType.USER]: PageType.GLOBAL,
        [ModelType.AREA]: PageType.GLOBAL,
        [ModelType.TEMPLATE]: PageType.GLOBAL,
        [ModelType.TAG]: PageType.GLOBAL,
        [PageIdentifier.ANALYTICS]: PageType.AREA,
        [PageIdentifier.HOME_DASHBOARDS]: PageType.AREA,
        [PageIdentifier.RULE_EXPERIMENTS]: PageType.AREA,
        [PageIdentifier.AUDIT_LOG]: PageType.GLOBAL,
        [PageIdentifier.RELEASE_NOTES]: PageType.GLOBAL,
        [PageIdentifier.EVALUATE]: PageType.AREA,
        [ModelType.SITE]: PageType.COLLECTION,
        [ModelType.AUTOCOMPLETE]: PageType.GLOBAL,
        [ModelType.RECS_MODEL]: PageType.COLLECTION,
        [ModelType.CATEGORIES]: PageType.GLOBAL,
        [ModelType.IMAGE_PATH]: PageType.GLOBAL,
        [PageIdentifier.SEARCH_DATA_QUALITY]: PageType.COLLECTION,
        [PageIdentifier.SEARCH_PERFORMANCE]: PageType.AREA,
        [PageIdentifier.SEO_DASHBOARD]: PageType.SITE,
        [PageIdentifier.KEYWORD_SUGGESTIONS]: PageType.SITE,
        [PageIdentifier.SITEMAP]: PageType.SITE,
        [PageIdentifier.SEO_SUITE_SETTINGS]: PageType.SITE,
        [ModelType.PREVIEW_WRAPPER]: PageType.GLOBAL,
    };
})(SearchForRetail || (SearchForRetail = {}));
